import React from 'react'
import Wpw from '../Projects/Wpw/Wpw'
import Projects from './Projects/Projects'

function Product() {
  return (
    <>
      <Wpw />
      <Projects />
    </>
  )
}

export default Product
